import "../App.css";
import Navbar from "../components/navbar/Navbar.js";
import Header from "../components/header/Header.js";
import Data from "../components/data/Data.js";
import Add from "../components/add/Add.js";
import Contact from "../components/contact/Contact.js";
import Footer from "../components/footer/Footer.js";
import BlurredContent from '../components/BlurredContent.js';
import SocialMedia from "../components/SocialMedia.js";
import YoloBot from "../components/chat-bot/chatBot.js";


const QuieroVender = () => {
    return (
        <div className="size">
            <Navbar />
            <SocialMedia/>
            <YoloBot/>
            <BlurredContent>
                <Header />
                <Data />
                <Add />
                <Contact />
            </BlurredContent>
            <Footer />
        </div>
    );
}

export default QuieroVender;
